import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  getWholesalerAccounts(wholesaler) {
    return defaultClient.get(`/wholesaler-accounts?${qs.stringify({ wholesaler })}`)
  },

  getAllWholesalers() {
    return defaultClient.get(`/wholesalers`)
  },
}
